export const FETCH_QUIZ_TEMPLATES_REQUEST = 'FETCH_QUIZ_TEMPLATES_REQUEST';
export const FETCH_QUIZ_TEMPLATES_SUCCESS = 'FETCH_QUIZ_TEMPLATES_SUCCESS';
export const FETCH_QUIZ_TEMPLATES_FAILURE = 'FETCH_QUIZ_TEMPLATES_FAILURE';
export const CREATE_QUIZ_REQUEST = 'CREATE_QUIZ_REQUEST';
export const CREATE_QUIZ_SUCCESS = 'CREATE_QUIZ_SUCCESS';
export const CREATE_QUIZ_FAILURE = 'CREATE_QUIZ_FAILURE';
export const UPDATE_QUIZ_REQUEST = 'UPDATE_QUIZ_REQUEST';
export const UPDATE_QUIZ_SUCCESS = 'UPDATE_QUIZ_SUCCESS';
export const UPDATE_QUIZ_FAILURE = 'UPDATE_QUIZ_FAILURE';
export const DELETE_QUIZ_REQUEST = 'DELETE_QUIZ_REQUEST';
export const DELETE_QUIZ_SUCCESS = 'DELETE_QUIZ_SUCCESS';
export const DELETE_QUIZ_FAILURE = 'DELETE_QUIZ_FAILURE';
export const FETCH_MY_QUIZZES_REQUEST = 'FETCH_MY_QUIZZES_REQUEST';
export const FETCH_MY_QUIZZES_SUCCESS = 'FETCH_MY_QUIZZES_SUCCESS';
export const FETCH_MY_QUIZZES_FAILURE = 'FETCH_MY_QUIZZES_FAILURE';